import DashboardPage from "./DashboardPage";
import CategoriesPage from "./CategoryListPage";
import ProductListPage from "./products/ProductListPage";
import ProductForm from "./products/ProductForm";
import ProfilePage from "./ProfilePage";
import SettingsPage from "./SettingsPage";
import SupplierListPage from "./supplier/SupplierListPage";
import SupplierDetailsPage from "./supplier/SupplierDetailsPage";
import InventoryPage from "./inventory/InventoryTransactionPage";
import PurchaseListPage from "./purchase/PurchaseListPage";
import PurchaseForm from "./purchase/PurchaseForm";
import CustomerListPage from "./CustomerListPage";
import SalesListPage from "./sales/SalesListPage";
import SalesForm from "./sales/SalesForm";
import SalesOrderDetailsPage from "./sales/SalesOrderDetailsPage";
import AdjustmentListPage from "./adjustment/AdjustmentListPage";
import AdjustmentForm from "./adjustment/AdjustmentForm";
import PurchaseOrderDetailsPage from "./purchase/PurchaseOrderDetailsPage";
import SupportRequestsPage from "./support/SupportRequestsPage";
import PlanUsagePage from "./PlanUsagePage";
import ReportsPage from "./ReportsPage";
import TeamManagementPage from "./team-management/TeamManagementPage";
import CreateEditUserPage from "./team-management/CreateEditUserPage";
import CreateEditRolePage from "./team-management/CreateEditRolePage";

export interface AppRoute {
  path: string;
  element: React.ReactElement;
  allowedRoles?: string[];
}

export const appRoutes: AppRoute[] = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/product/list", element: <ProductListPage /> },
  { path: "/product/create", element: <ProductForm /> },
  { path: "/product/:productId/edit", element: <ProductForm /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/category", element: <CategoriesPage /> },
  { path: "/supplier/list", element: <SupplierListPage /> },
  { path: "/supplier/:supplierId", element: <SupplierDetailsPage /> },
  { path: "/inventory", element: <InventoryPage /> },
  { path: "/purchase/list", element: <PurchaseListPage /> },
  { path: "/purchase/create", element: <PurchaseForm /> },
  { path: "/purchase/:purchaseId/edit", element: <PurchaseForm /> },
  {
    path: "/purchase/:orderId",
    element: <PurchaseOrderDetailsPage />,
  },
  { path: "/customer/list", element: <CustomerListPage /> },
  { path: "/support", element: <SupportRequestsPage /> },
  { path: "/plan-usage", element: <PlanUsagePage /> },
  { path: "/reports", element: <ReportsPage /> },
  { path: "/team-management", element: <TeamManagementPage /> },
  { path: "/team-management/user-list", element: <TeamManagementPage /> },
  { path: "/team-management/user/create", element: <CreateEditUserPage /> },
  {
    path: "/team-management/user/:tenantUserId/edit",
    element: <CreateEditUserPage />,
  },
  { path: "/team-management/role-list", element: <TeamManagementPage /> },
  { path: "/team-management/role/create", element: <CreateEditRolePage /> },
  {
    path: "/team-management/role/:tenantRoleId/edit",
    element: <CreateEditRolePage />,
  },
  { path: "/sale/list", element: <SalesListPage /> },
  { path: "/sale/create", element: <SalesForm /> },
  { path: "/sale/:saleId/edit", element: <SalesForm /> },
  { path: "/sale/:orderId", element: <SalesOrderDetailsPage /> },
  { path: "/adjustment/list", element: <AdjustmentListPage /> },
  { path: "/adjustment/create", element: <AdjustmentForm /> },
  { path: "/adjustment/:adjustmentId/edit", element: <AdjustmentForm /> },
];
